<mat-card  id="offspring-card" (click)="navigateToDetails(alpaca)" style="cursor: pointer;">
  <mat-card-header>
    <mat-card-title class="alpaca-shortname">
      {{ alpaca.shortName }}
    </mat-card-title>
      <div class="alpaca-fullname">{{alpaca.longName}}</div>
  </mat-card-header>
  <mat-card-content class="no-actions-content">
    <div class="card-body">
      <table>
        <tr>
          <td class="label">Geboortejaar:</td>
          <td>{{ alpaca.dateOfBirth | date: 'yyyy' }}</td>
        </tr>
        <tr>
          <td class="label">Vader:</td>
          <td>
            @if(alpaca.sire) { <div>{{ alpaca.sire.longName }}</div> }
          </td>
        </tr>
        <tr>
          <td class="label">Moeder:</td>
          <td>
            @if (alpaca.dam) { <div>{{ alpaca.dam.longName }}</div> }
          </td>
        </tr>
      </table>
    </div>
    <div class="card-body">
      <table>
        <tr>
          <td class="label">Soort:</td>
          <td>{{ alpaca.breed }}</td>
        </tr>
        <tr>
          <td class="label">Geslacht:</td>
          <td>{{ alpaca.gender }}</td>
        </tr>
        <tr>
          <td class="label">Kleur:</td>
          <td>{{ alpaca.color }}</td>
        </tr>
      </table>
    </div>
    <img loading="lazy" src="{{alpacaMainImageUrl}}{{alpaca.mainImage.name}}" alt="{{alpaca.longName}}" class="alpaca-image"/>
  </mat-card-content>
</mat-card>
  